var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 2.66659C5.05446 2.66659 2.66665 5.0544 2.66665 7.99992C2.66665 10.9454 5.05446 13.3333 7.99998 13.3333C10.9455 13.3333 13.3333 10.9454 13.3333 7.99992C13.3333 5.0544 10.9455 2.66659 7.99998 2.66659ZM1.33331 7.99992C1.33331 4.31802 4.31808 1.33325 7.99998 1.33325C11.6819 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 11.6818 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6818 1.33331 7.99992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 4.66675C8.36821 4.66675 8.66669 4.96522 8.66669 5.33341V7.33341H10.6667C11.0349 7.33341 11.3334 7.63189 11.3334 8.00008C11.3334 8.36827 11.0349 8.66675 10.6667 8.66675H8.66669V10.6667C8.66669 11.0349 8.36821 11.3334 8.00002 11.3334C7.63183 11.3334 7.33335 11.0349 7.33335 10.6667V8.66675H5.33335C4.96516 8.66675 4.66669 8.36827 4.66669 8.00008C4.66669 7.63189 4.96516 7.33341 5.33335 7.33341H7.33335V5.33341C7.33335 4.96522 7.63183 4.66675 8.00002 4.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/plusRounded.f34decbb.svg";
export { ForwardRef as ReactComponent };